"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

/**
 * Avisa al endpoint propio de métricas en cada cambio de ruta. El idioma del
 * navegador no viaja en el cuerpo: lo lee el servidor del Accept-Language.
 *
 * Es deliberadamente mínimo — no pone cookies ni identifica al visitante, así
 * que no requiere banner de consentimiento.
 */
export default function AnalyticsTracker() {
  const pathname = usePathname();
  const lastSent = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname || lastSent.current === pathname) return;
    lastSent.current = pathname;

    const body = JSON.stringify({ path: pathname });

    // sendBeacon sobrevive a la navegación; fetch queda como respaldo para
    // los navegadores que no lo soportan.
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        "/api/metrics",
        new Blob([body], { type: "application/json" }),
      );
      return;
    }
    void fetch("/api/metrics", {
      method: "POST",
      body,
      headers: { "Content-Type": "application/json" },
      keepalive: true,
    }).catch(() => {
      // Una métrica perdida no debe hacer ruido en la consola del usuario.
    });
  }, [pathname]);

  return null;
}
